var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalePurshaseEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 4.5,
    fill: "#F4F7FE",
    fillOpacity: 0.5,
    stroke: "#1C2B48"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_369_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.085 7.36914L5 13.4537V14.9996H6.54583L12.6304 8.91456L11.085 7.36914Z",
    fill: "#1C2B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6799 5.32004C14.4749 5.11512 14.1969 5 13.907 5C13.6172 5 13.3391 5.11512 13.1341 5.32004L11.6758 6.78046L13.2212 8.32588L14.6795 6.86754C14.7813 6.76602 14.862 6.64543 14.9171 6.51268C14.9722 6.37993 15.0006 6.23761 15.0006 6.09388C15.0007 5.95015 14.9724 5.80782 14.9173 5.67503C14.8623 5.54225 14.7816 5.42162 14.6799 5.32004Z",
    fill: "#1C2B48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalePurshaseEditIcon);
export default __webpack_public_path__ + "static/media/salePurshaseEditIcon.8c291d2d.svg";
export { ForwardRef as ReactComponent };